// extracted by mini-css-extract-plugin
export default {"pagination":"Pagination_pagination__LaiMh","pagination__arrow":"Pagination_pagination__arrow__1ZAwg","pagination__numbers":"Pagination_pagination__numbers__TeJmX"};